@import "@/styles/variables";

.modal {
	:global(.modal-dialog) {
		max-width: 600px;
	}

	:global(.modal-content) {
		border-radius: 12px;
		border: none;
	}

	:global(.modal-header) {
		border-bottom: 1px solid $gray-200;
		padding: 1.25rem 1.5rem;
		background: $gray-50;
		border-radius: 12px 12px 0 0;

		:global(.modal-title) {
			font-size: 1.125rem;
			font-weight: 600;
			color: $gray-700;
			display: flex;
			align-items: center;
			gap: 0.5rem;
		}
	}

	:global(.modal-body) {
		padding: 1.5rem;
	}

	:global(.modal-footer) {
		border-top: 1px solid $gray-200;
		padding: 1rem 1.5rem;
		background: $gray-50;
		border-radius: 0 0 12px 12px;
	}
}

.description {
	font-size: 0.875rem;
	color: $gray-500;
	margin-bottom: 0.5rem;
	line-height: 1.5;
}

.subtitle {
	font-size: 0.8125rem;
	color: $gray-400;
	margin-bottom: 1.25rem;
}

.listContainer {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	max-height: 400px;
	overflow-y: auto;
	margin-bottom: 1rem;
	padding-right: 0.25rem;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: $gray-100;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background: $gray-300;
		border-radius: 10px;

		&:hover {
			background: $gray-400;
		}
	}
}

.listItem {
	padding: 1rem;
	border: 1.5px solid $gray-200;
	border-radius: $border-radius;
	transition: all 0.2s ease;
	background: white;

	&:hover {
		border-color: $primary-color;
		background: $primary-light;
	}

	&.selected {
		border-color: $primary-color;
		background: $primary-light;
	}
}

.listContent {
	display: flex;
	align-items: center;
	gap: 0.75rem;
}

.checkboxWrapper {
	display: flex;
	align-items: center;
	cursor: pointer;

	input[type="checkbox"] {
		width: 18px;
		height: 18px;
		cursor: pointer;
		accent-color: $primary-color;
		appearance: none;
		border: 2px solid $gray-300;
		border-radius: 4px;
		position: relative;
		background: white;

		&:checked {
			background: $primary-color;
			border-color: $primary-color;

			&::after {
				content: "";
				position: absolute;
				left: 5px;
				top: 2px;
				width: 4px;
				height: 8px;
				border: solid white;
				border-width: 0 2px 2px 0;
				transform: rotate(45deg);
			}
		}
	}
}

.listInfo {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	flex: 1;
	cursor: pointer;
}

.listName {
	font-size: 0.9375rem;
	font-weight: 500;
	color: $gray-700;
	display: flex;
	align-items: center;
	gap: 0.375rem;
}

.contactCount {
	font-size: 0.8125rem;
	color: $gray-500;
	display: flex;
	align-items: center;
	gap: 0.25rem;
}

.badges {
	display: flex;
	gap: 0.5rem;
	align-items: center;
}

.badge {
	display: flex;
	align-items: center;
	gap: 0.25rem;
	padding: 0.25rem 0.5rem;
	border-radius: 6px;
	font-size: 0.75rem;
	font-weight: 500;

	&.email {
		background: $info-bg;
		color: $info-text;
	}

	&.whatsapp {
		background: $whatsapp-bg;
		color: $whatsapp-text;
	}

	svg {
		width: 12px;
		height: 12px;
	}
}

.summary {
	padding: 0.875rem 1rem;
	background: $primary-bg;
	border: 1px solid $primary-light;
	border-radius: $border-radius;
	margin-top: 0.75rem;
}

.summaryTitle {
	font-size: 0.75rem;
	font-weight: 600;
	color: $secondary-color;
	text-transform: uppercase;
	letter-spacing: 0.025em;
	margin-bottom: 0.375rem;
}

.summaryText {
	font-size: 0.875rem;
	color: $secondary-color;
	line-height: 1.5;
}

.selectorWrapper {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;
	margin-left: auto;
	padding-left: 1rem;
	flex-shrink: 0;
	width: 200px;
}

.selectorLabel {
	font-size: 0.75rem;
	font-weight: 500;
	color: $gray-600;
	white-space: nowrap;
	line-height: 1;
	margin: 0;
	padding: 0;
}

.warning {
	padding: 0.875rem 1rem;
	background: #fff3cd;
	border: 1px solid #ffc107;
	border-radius: $border-radius;
	margin-top: 0.75rem;
	text-align: center;

	span {
		font-size: 0.875rem;
		color: #856404;
		font-weight: 500;
	}
}

.actions {
	display: flex;
	gap: 0.75rem;
	justify-content: flex-end;
}

.btnCancel {
	padding: 0.625rem 1.25rem;
	border-radius: $border-radius;
	border: 1px solid $gray-300;
	background: white;
	color: $gray-600;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: $gray-50;
		border-color: $gray-400;
	}
}

.btnNext {
	padding: 0.625rem 1.25rem;
	border-radius: $border-radius;
	border: none;
	background: $primary-color;
	color: white;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: $primary-hover;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover {
			background: $primary-color;
		}
	}

	svg {
		width: 16px;
		height: 16px;
	}
}
